import React from 'react';
export function NavBar() {
  return <nav style={{
    padding: '16px',
    borderBottom: '1px solid #eee'
  }} data-id="element-1251" data-mp="3e3s3j7gs662b">
      <a href="/" style={{
      marginRight: '20px'
    }} data-id="element-1252" data-mp="2evdi3jby14q7">
        Home
      </a>
      <a href="/blog" style={{
      marginRight: '20px'
    }} data-id="element-1253" data-mp="2tmcmei5qx73z">
        Blog
      </a>
      <a href="/about" style={{
      marginRight: '20px'
    }} data-id="element-1254" data-mp="20vm6tqcta2fw">
        About
      </a>
      <a href="/faq" style={{
      marginRight: '20px'
    }} data-id="element-1255" data-mp="1vxkqhd6rsh84">
        FAQ
      </a>
    </nav>;
}